const DEGREES_FROM_SIDE_STRING = {
  top: 180,
  bottom: 0,
  left: 90,
  right: 270
};
const OPPOSITES = {
  top: 'bottom',
  bottom: 'top',
  left: 'right',
  right: 'left'
};

export { DEGREES_FROM_SIDE_STRING, OPPOSITES };
